import axios, { AxiosPromise } from 'axios';
import { IAkcionar } from 'types/akcionar';

const akcionarApi = (id: string): AxiosPromise<IAkcionar> => {
    return axios({
        method: 'GET',
        url: `Akcionar/${id}`
    });
};

export default akcionarApi;
